import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Title from "../components/Title";
import * as React from "react";
import TextField from "@mui/material/TextField";
import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Autocomplete from "@mui/material/Autocomplete";
import { AutocompleteUser, useUsers } from "../hooks/useUsers";
import { useWalletBalance } from "../hooks/useWalletBalance";
import { useWalletTransactions } from "../hooks/useWalletTransactions";
import { WalletBalance } from "../models/Wallet";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import LoadingSpinner from "../components/LoadingSpinner";
import WalletTransactionList from "../components/WalletTransactionList";
import CopyToClipboard from "../components/CopyToClipboard";
import { useMyOrders } from "../hooks/useMyOrders";
import { GridColDef } from '@mui/x-data-grid';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import ErrorFallBack from "../components/ErrorFallBack";



// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const window: any; // Needed for Hubspot


const Customers = () => {

  const [balanceRefreshKey] = useState(0);
  const [customerID, setCustomerID] = useState("");
  const { users, autocompleteUsers } = useUsers(0);
  const { walletBalance } = useWalletBalance(customerID, balanceRefreshKey)
  const [transactionsRefreshKey] = useState(0);
  const { walletTransactions, walletTransactionsLoading } = useWalletTransactions(customerID, transactionsRefreshKey)
  const [userName, setUserName] = useState("")
  const [userEmail, setUserEmail] = useState("")
  const [userPhone, setUserPhone] = useState("")
  const [userID, setUserID] = useState("")
  const [userSF, setUserSF] = useState("")
  const [userMinOrder, setUserMinOrder] = useState("")
  const [userfeatures, setUserFeatures] = useState("")
  const [phone, setPhone] = useState("")
  const [id, setID] = useState("")
  const [email, setEmail] = useState("")
  const [name, setName] = useState("")
  const [storefront, setSF] = useState("")
  const [features, setFeatures] = useState("")
  const [minorder, setMinOrder] = useState("")
  
  const columns: GridColDef[] = [
    { field: 'id', headerName: 'Order ID', width: 200 },
    { field: 'orderDate', headerName: 'Order Date', width: 200 },
    { field: 'description', headerName: 'Description', width: 150 },
    { field: 'hubSpotDealID', headerName: 'HubSpot Deal ID', width: 150 },
  ]

  
  const { orders, loading, error } = useMyOrders(customerID, balanceRefreshKey);
  
  
  const customerIDChanged = (event: React.SyntheticEvent<Element, Event>, value: AutocompleteUser | null) => {
    if (value == null) {
      setCustomerID("")
    } else {
      setCustomerID(value.id)

      for (const user of users) {
        if (user.id == value.id) {
          setUserID(user.id)
          setUserName(user.firstName + ' ' + user.lastName)
          setUserEmail(user.email)
          setUserPhone(user.phone)
          setUserSF(user.storefrontName)
          setUserMinOrder(user.settings.minOrderAmount.toString())
          setID('Customer ID:')
          setName('Name:')
          setEmail('Email:')
          setPhone('Phone:')
          setSF('StoreFront:')
          setMinOrder('Min Order:')      
  
        
          if (user.features != null) {
          setUserFeatures(user.features.toString())
          setFeatures('Features:')
          }
    }
  }
}
}

  const getWalletBalance = (wb: WalletBalance | undefined) => {
    if (wb != undefined && wb.balance != undefined) {
        return wb.balance + " leads"
    }

    return "0 leads"
  }


  useEffect(() => {
    const _hsq = (window._hsq = window._hsq || []);
    _hsq.push(["setPath", "/Customers"]);
    _hsq.push(["trackPageView"]);
  }, []);


  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
            <Title>Customers</Title>
            <Box sx={{ width: 600, marginTop: 2 }}>
              <Autocomplete
                disablePortal
                isOptionEqualToValue={(
                  option: AutocompleteUser,
                  value: AutocompleteUser
                ) => option.id === value.id}
                id="existingCustomer"
                onChange={customerIDChanged}
                options={autocompleteUsers}
                size="small"
                sx={{ width: 360 }}
                renderInput={(params) => (
                  <TextField {...params} label="Customer Name" />
                  
                )}
                
              />

            </Box>

            { customerID != "" &&
              <Grid sx={{marginTop:2}} >
                <Stack direction="row" alignItems="center" spacing={2}>
                    <Typography  sx={{width:100}}>{id}</Typography>
                    <Typography  sx={{}}>{userID} <CopyToClipboard value={userID}></CopyToClipboard> </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={2}>
                    <Typography sx={{width:100}}>{name}</Typography>
                    <Typography sx={{}}>{userName}</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={2}>
                    <Typography sx={{width:100}}>{phone}</Typography>
                    <Typography sx={{}}>{userPhone}</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={2}>
                    <Typography sx={{width:100}}>{email}</Typography>
                    <Typography sx={{}}>{userEmail} <CopyToClipboard value={userEmail} /></Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={2}>
                    <Typography sx={{width:100}}>{storefront}</Typography>
                    <Typography sx={{}}>{userSF}</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={2}>
                    <Typography sx={{width:100}}>{minorder}</Typography>
                    <Typography sx={{}}>{userMinOrder}</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={2}>
                    <Typography sx={{width:100}}>{features}</Typography>
                    <Typography sx={{}}>{userfeatures}</Typography>
                </Stack>
              </Grid>
            }

            <Box sx={{marginTop:2}}>
                        <Stack direction="row" spacing={2}>
                            <Typography sx={{}}>Wallet Balance:</Typography>
                            <Typography>{getWalletBalance(walletBalance)}</Typography>
                        </Stack>
                    </Box>

                  {}

                  <Grid marginTop={4} height={300}>
                  <Typography sx={{fontWeight:"bold"}}>Customer Orders:</Typography>
                  {loading
                    ? <LoadingSpinner />
                    : error
                    ? <ErrorFallBack message={error}/>
                    :
                    <DataGridPremium
                    rows={orders}
                    columns={columns}
                    initialState={{
                      pagination: {
                        paginationModel: { page: 0, pageSize: 10 },
                      },
                      sorting: {
                        sortModel: [{ field: 'id', sort: 'desc' }],
                      },
                    }}
                    pageSizeOptions={[5, 10, 25, 50]}
 
                  />
                    }
                  </Grid>

                    <Box sx={{marginTop:4, minWidth:460}}>
                        <Stack direction="column" spacing={0}>
                            <Typography sx={{fontWeight:"bold",mt:2}}>Wallet Transactions:</Typography>
                            { walletTransactionsLoading
                              ? <LoadingSpinner />
                              : <WalletTransactionList transactions={walletTransactions} height={300} />
                            }
                        </Stack>
                    </Box>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Customers;
